module.exports = __webpack_public_path__ + "static/img/zhuapaijilu.a74bf73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/zhuapaijilu.png
// module id = YWEC
// module chunks = 24